import React from 'react';
import searchParamsParser from "@Utils/searchParamsParser";
import searchParamsStringify from "@Utils/searchParamsStringify";
import stringSanitizer from "stringSanitizer";
import removeSpacesFromText from "removeSpacesFromText";

function Breadcrumbs({ breadcrumbs, data, currentRoute }) {
  let baseUrl = currentRoute && currentRoute.path ? currentRoute.path.replace(':searchParams*', '') : null;
  let searchParams = currentRoute && currentRoute.url ? searchParamsParser(currentRoute.url) : null;
  let specialismOptions  = data && data.specialismOptions ? data.specialismOptions : null;
  let geoData  = data && data.geoData ? data.geoData : null;
  const breadcrumbList = [];
  if (breadcrumbs && breadcrumbs.items !== undefined) {
    breadcrumbs.items.map((breadcrumb) => {
      if (breadcrumb.link !== null) {
        breadcrumbList.push(
          <li className="breadcrumb__item" key={stringSanitizer(breadcrumb.title)}>
            <a href={breadcrumb.link} className="breadcrumb__link">{breadcrumb.title}</a>
          </li>
        );
      }
      else {
        breadcrumbList.push(
            <li className="breadcrumb__item" key={stringSanitizer(breadcrumb.title)}>{breadcrumb.title}</li>
        );
      }
    });
  } else {
    return null;
  }
  const breadcrumbItems = {
    specialism: {
      nullValues: [
        'location',
        'type',
        'page',
        'distance'
      ],
    },
    location: {
      nullValues: [
        'type',
        'page',
        'distance'
      ],
    },
  };

  for (let paramName in breadcrumbItems) {
    if (searchParams && searchParams[paramName]) {
      if (paramName === "specialism" && specialismOptions) {
        for (let key in specialismOptions) {
          let facetValue = specialismOptions[key].name ? stringSanitizer(specialismOptions[key].name).toLowerCase() : null;
          let facetName = specialismOptions[key].name ? specialismOptions[key].name.toLowerCase() : null;
          if (facetValue === searchParams[paramName]) {
            let facetBuilder = Object.assign({}, searchParams);
            breadcrumbItems[paramName].nullValues.forEach(facetName => {
              facetBuilder[facetName] = null;
            });
            facetBuilder[paramName] = facetValue;
            let url = `${baseUrl}${searchParamsStringify(facetBuilder)}`;
            breadcrumbList.push(
              <li className="breadcrumb__item" key={paramName}>
                <a className="breadcrumb__link" href={url}>
                  {facetName}
                </a>
              </li>
            );
          }
        }
      }
      else if (paramName === "location" && geoData) {
        let facetValue = geoData.locality && geoData.locality.length > 0 ? removeSpacesFromText(geoData.locality[0]) : null;
        let facetName = geoData.locality && geoData.locality.length > 0 ? geoData.locality[0].toLowerCase() : null;
        if (facetValue === searchParams[paramName]) {
          let facetBuilder = Object.assign({}, searchParams);
          breadcrumbItems[paramName].nullValues.forEach(facetName => {
            facetBuilder[facetName] = null;
          });
          facetBuilder[paramName] = searchParams[paramName];
          let url = `${baseUrl}${searchParamsStringify(facetBuilder)}`;
          breadcrumbList.push(
            <li className="breadcrumb__item" key={paramName}>
              <a className="breadcrumb__link" href={url}>
                {facetName}
              </a>
            </li>
          );
        }
      }
    }
  }
  // Remove the link from the last element.
  const lastElement = breadcrumbList[breadcrumbList.length-1];
  const lastElementChildren = lastElement && lastElement.props ? lastElement.props.children : [];
  if (lastElementChildren && lastElementChildren.props && lastElementChildren && lastElementChildren.props.children) {
    breadcrumbList[breadcrumbList.length-1] =  breadcrumbList.length > 1 ? React.cloneElement(lastElement, {children: lastElementChildren.props.children}) : breadcrumbList[breadcrumbList.length-1];
  }
  // Get the last but one breadcrumb element and add class to it.
  const lastButOneElement = breadcrumbList.length === 1 ? lastElementChildren : typeof (breadcrumbList[breadcrumbList.length-2].props.children) === 'object' ? breadcrumbList[breadcrumbList.length-2].props.children : breadcrumbList[breadcrumbList.length-2];
  const breadcrumbsMobile = React.cloneElement(lastButOneElement, {className: "breadcrumb__link hidden--from-l"});

  return (
    <div className="navigation__bottom">
      <nav className="breadcrumb" aria-label="breadcrumb">
        {breadcrumbsMobile}
        <ul className="breadcrumb__list hidden--until-l">
          {breadcrumbList}
        </ul>
      </nav>
    </div>
  )
}

export default Breadcrumbs;
